import React from 'react';

import { finleyAssert, finleyBuffer } from '@finley-technologies/common';
import { FinleyBuffer } from '@finley-technologies/finley-types';

import { DownloadIconButton } from 'packages/common-frontend/components/IconButton';
import { fileExtensionToMimeTypeMap } from 'packages/common-frontend/utils';

type ExportBufferButtonProps = {
  filename: string;
  buffer: ArrayBuffer | FinleyBuffer | null;
};
export const ExportBufferButton = ({
  filename,
  buffer,
}: ExportBufferButtonProps) => {
  const fileExt = filename.split('.').pop() || 'csv';

  const type = fileExtensionToMimeTypeMap[fileExt];
  finleyAssert(type, `[${fileExt}] is not supported file mime type`);

  const download = () => {
    if (buffer) {
      const bufferData =
        buffer instanceof ArrayBuffer
          ? buffer
          : finleyBuffer.toArrayBuffer(buffer);
      const blob = new Blob([bufferData], { type });
      const href = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = href;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <DownloadIconButton
      isDisabled={!buffer}
      ariaLabel="download"
      label="Download"
      onClick={() => download()}
    />
  );
};
